export const GET_DETAILS_DEVICE_BY_ADMIN = 'GET_DETAILS_DEVICE_BY_ADMIN'
export const GET_DETAILS_DEVICE_BY_ADMIN_ERR = 'GET_DETAILS_DEVICE_BY_ADMIN_ERR'

export const RESET_DETAILS_DEVICE = 'RESET_DETAILS_DEVICE'